import "./ManageRevisionHistory.scoped.scss";
import pdfIcon from "media/icons/dls/pdf.svg";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { loadSWRevisionHistories } from "store/manageSW/manageSWActions";
import useSelector from "store/useSelector";
import { ISWRevisionHistory, IUserApprovalResponseHistory, SWTypes } from "interfaces/sw/SWInterfaces";
import formatDate from "utilities/formatDate";
import { getPDF } from "store/swList/swListActions";
import { Link } from "react-router-dom";
import { Routes } from "components/routing/Routing";

interface IManageSWRevHistoryProps {
    swGuid: string,
    swType: SWTypes,
}

const ManageRevisionHistory: React.FC<IManageSWRevHistoryProps> = ({ swGuid, swType }) => {
    const {
        manageSW: {
            revisionHistories
        },
    } = useSelector(store => store);
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(loadSWRevisionHistories({ swGuid }));
    }, [dispatch, swGuid]);

    const PdfClick = (id: number) => {
        dispatch(getPDF({
            swId: id,
            generateDefault: true
        }))
    }

    const [showAllContributors, setShowAllContributors] = useState<boolean>(false);

    const handleToggle = () => {
        setShowAllContributors(!showAllContributors);
    };

    return (
        <div>
            <div className="row header">
                <div className="cell version">
                    Version
                </div>
                <div className="cell publishdate">
                    Publish Date
                </div>
                <div className="cell description" >
                    Description
                </div>
                <div className="cell contibutors" >
                    Contributor(s)
                </div>
                <div className="cell author" >
                    Approver(s)
                </div>
                <div className="cell buttons" >
                    Download PDF
                </div>
            </div>
            <div className="list-body">
                {
                    revisionHistories?.map((revisionHistoryItem: ISWRevisionHistory, ix: number) => (
                        <div className="row-value row" key={ix.toString()}>
                            <Link
                                //className="sw-link"
                                className="cell version"
                                target="_blank"
                                to={Routes.ViewStandardWork.replace(
                                    ":guid",
                                    revisionHistoryItem.guid
                                ).replace(":version", revisionHistoryItem.version)}
                            >
                                {revisionHistoryItem.version}
                            </Link>
                            {/* <div className="cell version">
                                {revisionHistoryItem.version}
                            </div> */}
                            <div className="cell publishdate">
                                {revisionHistoryItem.publishDate ? formatDate(revisionHistoryItem.publishDate) : "Draft"}
                            </div>
                            <div className="cell description">
                                {revisionHistoryItem.description}
                            </div>
                            <div className="cell contibutors">
                                <span>
                                    {showAllContributors
                                        ? revisionHistoryItem.contributors.join(', ')
                                        : revisionHistoryItem.contributors.slice(0, 3).join(', ')
                                    }
                                </span>
                                {revisionHistoryItem.contributors.length > 3 && (
                                    <span className="clickable-text" onClick={handleToggle} >
                                        {showAllContributors ? '  Show less' : '  ...Show more'}
                                    </span>
                                )}
                            </div>
                            <div className="cell author">
                                {revisionHistoryItem.approvalResponses.map((approvalResponse: IUserApprovalResponseHistory) => (
                                    <span>
                                        {
                                            (
                                                ((approvalResponse.level !== "") &&
                                                    (approvalResponse.userName !== null) &&
                                                    <><b>{approvalResponse.level}: </b>{approvalResponse.userName}<br /></>) ||

                                                ((approvalResponse.level !== "") &&
                                                    (approvalResponse.userName == null) &&
                                                    <><b>{approvalResponse.level}: </b>{approvalResponse.userEmail}<br /></>) ||

                                                ((approvalResponse.level === "") &&
                                                    (approvalResponse.userName != null) &&
                                                    <>{approvalResponse.userName}<br /></>) ||

                                                ((approvalResponse.level === "") &&
                                                    (approvalResponse.userName == null) &&
                                                    <>{approvalResponse.userEmail}<br /></>)
                                            )
                                        }
                                    </span>
                                ))}
                            </div>
                            <div className="cell buttons">
                                <img src={pdfIcon} className="icon-medium hover-image" alt="Download PDF" onClick={() => PdfClick(revisionHistoryItem.id)} />
                            </div>
                        </div>
                    ))
                }

            </div>
        </div>);
}

export default ManageRevisionHistory;